export default "__VITE_ASSET__140977df__"